//2024/01/12 [2023L-14] add start
import { Mutation, Action, VuexModule, getModule, Module } from 'vuex-module-decorators';
import store from '@/store';
import { IProcessHistories } from '../dto/ProcessHistories';

@Module({ dynamic: true, store, name: 'processHistories', namespaced: true })
class ProcessHistories extends VuexModule {
    /**
     * @state
     * 申請履歴画面表示用データ、戻り先画面の情報を格納する。
     */
    processHistories: any = [];

    /**
     * @state
     * 遷移元（業者明細画面に遷移する前の元画面を保存）
     */
    transitionSourceScreen: string = '';

    /**
     * @state
     * 業者番号キー
     */
    traderId: string = '';

    /**
     * @state
     * 再検索フラグ
     * ='1'の時再検索を行う
     */
    reSearchFlagProcessHistories = '0';

    /**
     * @state
     * フォームデータ
     * 検索条件を格納する
     */
    formData: any = [];

    /**
     * @state
     * ポップアップ表示用の受理/不受理通知内容
     */
    jyuriFujyuriNaiyou: string = '';

    /**
     * @Getter
     * 申請履歴画面表示用データ
     */
    get GET_PROCESS_HISTRIES() {
        return this.processHistories;
    }

    /**
     * @Getter
     * 遷移元を返す
     * @returns string
     */
    get GET_TRANSITION_SOURCE_SCREEN() {
        return this.transitionSourceScreen;
    }

    /**
     * @Getter
     * 業者番号キーを返す
     * @returns string
     */
    get GET_TRADER_ID() {
        return this.traderId;
    }

    /**
     * @Getter
     * 業者番号キーが設定されていればtrueを返す
     * @returns boolean
     */
    get IS_SET_TRADER_ID() {
        if (!this.traderId || this.traderId === '') {
            return false;
        }
        return true;
    }

    /**
     * @getter
     * reSearchFlagProcessHistoriesの取得
     * 1ならtrueを返す
     */
    get CHECK_RE_SEARCH_PROCESS_HISTORIES() {
        if (this.reSearchFlagProcessHistories === '1') {
            return true;
        }
        return false;
    }

    /**
     * @Getter
     * formDataの取得
     */
    get GET_FORM_DATA() {
        return this.formData;
    }

    /**
     * @Getter
     * jyuriFujyuriNaiyouの取得
     */
    get GET_JYURI_FUJYURI_NAIYOU() {
        return this.jyuriFujyuriNaiyou;
    }

    /**
     * @Action
     * 業者番号キーを格納する
     */
    @Action({})
    public setTraderId(param: string) {
        this.SET_TRADER_ID(param);
    }

    /**
     * @Action
     * フォームデータの保管
     * @param data
     */
    @Action({})
    public setFormData(data: any) {
        this.SET_FORM_DATA(data);
    }

    /**
     * @Action
     * フォームデータのリセット
     * @param data
     */
    @Action({})
    public resetFormData() {
        this.RESET_FORM_DATA();
    }

    /**
     * @Action
     * 遷移元を設定する
     */
    @Action({})
    public setTransitionSourceScreen(param: string) {
        this.SET_TRANSITION_SOURCE_SCREEN(param);
    }

    /**
     * @Action
     * 申請履歴画面表示用データ、戻り先画面の情報を格納する
     * @param param ProcessHistories
     */
    @Action({})
    public setProcessHistories(param: ProcessHistories) {
        this.SET_PROCESS_HISTRIES(param);
    }

    @Mutation
    private SET_PROCESS_HISTRIES(param: IProcessHistories) {
        this.processHistories = param;
    }

    @Mutation
    private SET_TRANSITION_SOURCE_SCREEN(param: string) {
        this.transitionSourceScreen = param;
    }

    @Mutation
    private SET_TRADER_ID(param: string) {
        this.traderId = param;
    }

    @Mutation
    private SET_FORM_DATA(data: any) {
        this.reSearchFlagProcessHistories = '1';
        this.formData = data;
    }

    @Mutation
    private RESET_FORM_DATA() {
        this.reSearchFlagProcessHistories = '0';
        this.formData = [];
    }

}

export const processHistoriesModule = getModule(ProcessHistories);
//2024/01/12 [2023L-14] add end
